import React from 'react';
import Layout from './components/Layout';
import SharePointGrid from './components/SharePointGrid';
import DocumentDataGrid from './components/DocumentDataGrid';

import { CssBaseline, Container, Typography } from '@mui/material';


function App() {
  return (
    <>
      <CssBaseline />
      <Layout> 
      <Container>
        <Typography variant="h4" gutterBottom mt={2}>
          Cabot-Koppers Superfund Document Search
        </Typography>
        {/*<SharePointGrid />*/}

        <DocumentDataGrid/>
 

      </Container>
             </Layout>
    </>
  );
}

export default App;
